<template>
  <div>
    <ErrorView ref="errorView"/>
    <PlaylistResult v-if="playlist" :items="playlist"/>
    <ResultDefault v-else-if="resultDefault" :data="resultDefault"/>
  </div>
</template>

<script>
import ErrorView from "./ErrorView.vue";
import ResultDefault from "./ResultDefault.vue";
import PlaylistResult from "./PlaylistResult.vue";
import validURL from "../tools/validUrl";
import { isPlaylistResponse } from "../tools/playlist";
import Api from "../api/Api";

export default {
  name: "LinkAnalyzerView",
  components: { ErrorView, ResultDefault, PlaylistResult },
  data() {
    return {
      resultDefault: null,
      // ответ на ссылку YouTube-плейлиста — массив заглушек, рисуется PlaylistResult
      playlist: null,
      isSubmitting: false,
    }
  },
  mounted() {
    this.form = document.getElementById('main-form')
    this.input = document.getElementById('id_url')
    this.loader = document.getElementById('loader')

    if (!this.form || !this.input) return

    this.form.addEventListener('submit', this.onSubmit)
    this.input.addEventListener('paste', this.onPaste)
    this.input.addEventListener('input', this.onInput)
  },

  beforeDestroy() {
    this.form?.removeEventListener('submit', this.onSubmit)
    this.input?.removeEventListener('paste', this.onPaste)
    this.input?.removeEventListener('input', this.onInput)
  },

  methods: {
    async onSubmit(e) {
      e.preventDefault()

      this.$refs.errorView.hide()
      if (this.isSubmitting) return
      this.isSubmitting = true

      this.resultDefault = null
      this.playlist = null

      const url = this.input.value.trim()

      try {
        if (!validURL(url)) throw new Error("NOT_VALID")
        this.$root.$emit('link-submit', url)
        this.showLoader(true)

        const data = await this.runDefaultRequest(url)
        if (isPlaylistResponse(url, data)) {
          this.playlist = data
        } else {
          this.resultDefault = Array.isArray(data) ? data : [data]
        }

      } catch (e) {
        this.$refs.errorView.show(e)
      } finally {
        this.isSubmitting = false
        this.showLoader(false)
      }
    },

    async runDefaultRequest(url) {
      const res = await Api.requestToLink({
        url,
        subscribeSignedRequestBody: this.$root.subscribeSignedRequestBody
      })

      if (res.data?.success === false) {
        throw new Error(res.data.message)
      }
      this.$root.$emit('show-results', res.data)

      return res.data
    },

    onPaste(e) {
      this.input.value = (e.clipboardData || window.clipboardData).getData('text')
      this.onSubmit(e)
    },

    onInput(e) {
      this.$emit('link-cast', e.target.value)
    },

    showLoader(state = true) {
      this.loader.style.display = state === true
        ? 'flex'
        : 'none'
    },
  }
}
</script>
